import componentsDictionary from "./componentsDictionary.js"

/**
 * This function will transform received schema into consumable schema for form components
 * It sources components from dictionary or as a plain component object
 * It computes model field from bindTo
 */
export const computeSchema = schema => {
	return schema.map(item => {
		const { name, props } = componentsDictionary(item.component)
		return {
			...item,

			// merge props from schema with props from componentDictionary
			props: { ...props, ...item.props },

			// if we got name from componentsDictionary, use it, otherwise use componentObject which is a component as an object
			component: name ? name : item.componentObject?.source,

			// Last part of bindTo will become dynamicType
			// This is being used e.g. when we are creating facts: dynamicType will become type of fact
			dynamicType: item?.bindTo?.split(".")?.slice(-1)?.[0] || ""
		}
	})
}
